import styled from "styled-components";

export const Pagination = styled.div`
  position: fixed;
  width: 100%;
  max-width: 500px;
  bottom: 0px;
  padding: 30px 0px 15px;
  background: #fff;
  left: 50%;
  transform: translate(-50%);
`;
export const PaginationUl = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-around;
  list-style: none;
  margin: 0 auto;
  padding: 0px;
`;
export const PaginationItem = styled.li``;

export const BtnPrev = styled.button`
  padding: 10px;
  border-radius: 10px;
  background: #eaf9f8;
  color: #4495b2;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
  width: 97px;
  height: 46px;
  @media (max-width: 327px) {
    font-size: 12px;
    width: 80px;
  }
`;
export const Svg = styled.span`
  margin-top: 6px;
  @media (max-width: 327px) {
    font-size: 12px;
  }
`;

export const BtnNext = styled.button`
  padding: 10px;
  border-radius: 10px;
  background: var(
    --linear,
    linear-gradient(164deg, #5ed2d2 0%, #5ed2b7 58.45%)
  );
  :disabled {
    cursor: not-allowed !important;
    background-color: red !important;
  }
  box-shadow: 0px 4px 10px 0px rgba(95, 211, 183, 0.4);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
  width: 97px;
  height: 46px;
  @media (max-width: 327px) {
    font-size: 12px;
    width: 80px;
  }
`;

export const Step = styled.p`
  border-radius: 50%;
  background: #eaedf1;
  height: 6px;
  width: 6px;
  margin: 0px 3px;
`;
